module.exports = __webpack_public_path__ + "static/media/wood-1.f8111f19.gif";